import { useQuery } from '@tanstack/react-query'
import { getFilePool } from '../api/data-connectors/filepool'

export function useGetFilePool() {
  return useQuery({
    queryKey: ['filepool'],
    queryFn: () => getFilePool(),
    staleTime: 600_000, // 10 minutes
  })
}
